const getRefType = (ref, refType) => {
    return !!ref && typeof ref === refType;
};
export const combineRefs = (...refs) => {
    return (el) => {
        refs.forEach(ref => {
            const isObjectRef = getRefType(ref, 'object');
            const isCallbackRef = getRefType(ref, 'function');
            if (isObjectRef) {
                ;
                ref.current = el;
            }
            if (isCallbackRef) {
                ;
                ref(el);
            }
        });
    };
};
//# sourceMappingURL=combineRefs.js.map